import api from './api.service';

type ApiBody<T> = { success?: boolean; data?: T; message?: string };

async function unwrap<T>(promise: Promise<unknown>): Promise<T> {
  const body = (await promise) as ApiBody<T>;
  if (body?.data === undefined) throw new Error(body?.message || 'Configuration request failed');
  return body.data;
}

export const configurationService = {
  getRuntime: () => unwrap<Record<string, unknown>>(api.get('/configuration/runtime')),
  getOverview: () => unwrap<Record<string, unknown>>(api.get('/configuration/studio/overview')),
  getSolutionPacks: () => unwrap<Record<string, unknown>>(api.get('/configuration/solution-packs')),
  install: (packKey: string, confirm = false) =>
    unwrap<Record<string, unknown>>(api.post('/configuration/install', { packKey, confirm })),
  uninstall: (packKey: string, confirm = false) =>
    unwrap<Record<string, unknown>>(api.post('/configuration/uninstall', { packKey, confirm })),
  getModules: () => unwrap<Record<string, unknown>>(api.get('/configuration/modules')),
  getFeatures: () => unwrap<Record<string, unknown>>(api.get('/configuration/features')),
  patchFeature: (featureKey: string, status: string) =>
    unwrap<Record<string, unknown>>(api.patch('/configuration/features', { featureKey, status })),
  getTerminology: (packKey?: string) =>
    unwrap<Record<string, unknown>>(
      api.get('/configuration/terminology', { params: packKey ? { packKey } : {} })
    ),
  patchTerminology: (payload: Record<string, unknown>) =>
    unwrap<Record<string, unknown>>(api.patch('/configuration/terminology', payload)),
  getWorkflows: () => unwrap<Record<string, unknown>>(api.get('/configuration/workflows')),
  getReports: () => unwrap<Record<string, unknown>>(api.get('/configuration/reports')),
  getForms: () => unwrap<Record<string, unknown>>(api.get('/configuration/forms')),
  getMenus: () => unwrap<Record<string, unknown>>(api.get('/configuration/menus')),
  getDashboards: () => unwrap<Record<string, unknown>>(api.get('/configuration/dashboards')),
  getAi: () => unwrap<Record<string, unknown>>(api.get('/configuration/ai')),
  getCompliance: () => unwrap<Record<string, unknown>>(api.get('/configuration/compliance')),
  getLocalization: () => unwrap<Record<string, unknown>>(api.get('/configuration/localization')),
  getPermissions: () => unwrap<Record<string, unknown>>(api.get('/configuration/permissions')),
  getDiagnostics: () => unwrap<Record<string, unknown>>(api.get('/configuration/diagnostics')),
  getOverrides: () => unwrap<Record<string, unknown>>(api.get('/configuration/overrides')),
  upgradePreview: () =>
    unwrap<Record<string, unknown>>(api.post('/configuration/upgrade/preview', {})),
};
